import { useEffect, useRef, useState } from "react";
import QRCodeStyling from "qr-code-styling";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import logotw_circle from "../../../../../assets/imgs/logotw_circle.png";

interface IModalEnlaceProceso {
  list: string[];
  listaOriginal: any[];
}

interface IProcesoEnlaceItem {
  busquedaId: string;
  cargoNombre: string;
  clienteNombre: string;
}

const buildQrCode = (data: string) =>
  new QRCodeStyling({
    width: 200,
    height: 200,
    margin: 0,
    data,
    image: logotw_circle,
    backgroundOptions: { color: "#fff" },
    imageOptions: {
      hideBackgroundDots: false,
      crossOrigin: "anonymous",
    },
    dotsOptions: {
      type: "square",
      gradient: {
        type: "linear",
        rotation: 45,
        colorStops: [
          { offset: 0, color: "#0065DD" },
          { offset: 1, color: "#FF0081" },
        ],
      },
    },
  });

const ProcesoEnlaceItem = ({
  busquedaId,
  cargoNombre,
  clienteNombre,
}: IProcesoEnlaceItem) => {
  const qrRef = useRef<HTMLDivElement>(null);
  const [copied, setCopied] = useState(false);
  const url = `${process.env.REACT_APP_link_postulacion}/vacante/${busquedaId}`;

  useEffect(() => {
    if (qrRef.current) {
      qrRef.current.innerHTML = "";
      buildQrCode(url).append(qrRef.current);
    }
  }, [url]);

  const handleCopy = () => {
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div
      className="flex flex-column align-items-center gap-3 p-3"
      style={{
        borderBottom: "1px solid #e5e7eb",
        paddingBottom: "24px",
      }}
    >
      <div className="flex flex-column align-items-start w-full gap-1">
        <span style={{ fontWeight: 700, fontSize: "14px", color: "#333" }}>
          {cargoNombre}
        </span>
        <span style={{ fontSize: "13px", color: "#6f6f6f" }}>
          {clienteNombre} — ID: {busquedaId}
        </span>
      </div>

      <div ref={qrRef} />

      <div className="flex align-items-center gap-2" style={{ width: "100%" }}>
        <input
          readOnly
          value={url}
          style={{
            flex: 1,
            padding: "8px 12px",
            border: "1px solid #d1d5db",
            borderRadius: "6px",
            fontSize: "13px",
            color: "#333",
            background: "#fafafa",
            outline: "none",
          }}
        />
        <button
          onClick={handleCopy}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            padding: "8px 14px",
            border: "none",
            borderRadius: "6px",
            background: copied ? "#06A502" : "#0065DD",
            color: "#fff",
            cursor: "pointer",
            fontSize: "13px",
            fontWeight: 500,
            whiteSpace: "nowrap",
            transition: "background 0.2s",
          }}
        >
          {copied ? (
            <CheckIcon style={{ fontSize: 16 }} />
          ) : (
            <ContentCopyIcon style={{ fontSize: 16 }} />
          )}
          {copied ? "Copiado" : "Copiar enlace"}
        </button>
      </div>
    </div>
  );
};

export default ({ list, listaOriginal }: IModalEnlaceProceso) => {
  const procesos = listaOriginal.filter(({ busquedaId }: any) =>
    list.includes(busquedaId)
  );

  return (
    <section className="content-table-restaurar" style={{ gap: "0" }}>
      {procesos.map(({ busquedaId, cargoNombre, clienteNombre }: any) => (
        <ProcesoEnlaceItem
          key={busquedaId}
          busquedaId={busquedaId}
          cargoNombre={cargoNombre}
          clienteNombre={clienteNombre}
        />
      ))}
    </section>
  );
};
